"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class ApiService {
    /**
     * Deleting a user account
     * @returns void
     * @throws ApiError
     */
    static apiAccountProfileDeleteDestroy() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/api/account/profile/delete',
        });
    }
    /**
     * Эндпоинт отключен, так как оценка в конце упражнения была убрана.
     * @returns any No response body
     * @throws ApiError
     */
    static apiAddFeedbackCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/add_feedback',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiCategoriesErrorRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/categories_error',
        });
    }
    /**
     * Info for mistake users in exercise
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param keyPeriod Key for period chart
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsAvgModulesList(dateEnd = '2024-07-05', dateStart = '2024-06-05', keyPeriod, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/avg_modules',
            query: {
                'date_end': dateEnd,
                'date_start': dateStart,
                'key_period': keyPeriod,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Отдает список выполненных упражнений
     * @returns any No response body
     * @throws ApiError
     */
    static apiChartsCompletedExercisesRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/completed_exercises',
        });
    }
    /**
     * Info for mistake users in exercise
     * @param byDay
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param group
     * @param keyPeriod Key for period chart
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsCountCategoriesList(byDay, dateEnd = '2024-07-05', dateStart = '2024-06-05', group, keyPeriod, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/count_categories',
            query: {
                'by_day': byDay,
                'date_end': dateEnd,
                'date_start': dateStart,
                'group': group,
                'key_period': keyPeriod,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Info for mistake users in exercise
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param keyPeriod Key for period chart
     * @param moduleId id module chart (Not required)
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsCountTimeList(dateEnd = '2024-07-05', dateStart = '2024-06-05', keyPeriod, moduleId, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/count_time',
            query: {
                'date_end': dateEnd,
                'date_start': dateStart,
                'key_period': keyPeriod,
                'module_id': moduleId,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Info for mistake users in exercise
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param keyPeriod Key for period chart
     * @param moduleId id module chart (Not required)
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsMistakeTableList(dateEnd = '2024-07-05', dateStart = '2024-06-05', keyPeriod, moduleId, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/mistake_table',
            query: {
                'date_end': dateEnd,
                'date_start': dateStart,
                'key_period': keyPeriod,
                'module_id': moduleId,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Info for mistake users in exercise
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param keyPeriod Key for period chart
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsProgressModulesList(dateEnd = '2024-07-05', dateStart = '2024-06-05', keyPeriod, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/progress_modules',
            query: {
                'date_end': dateEnd,
                'date_start': dateStart,
                'key_period': keyPeriod,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Info for mistake users in exercise
     * @param dateEnd Формат должен быть Y(год)-m(месяц)-d(день)
     * @param dateStart Формат должен быть Y(год)-m(месяц)-d(день)
     * @param keyPeriod Key for period chart
     * @param moduleId id module chart (Not required)
     * @param user param for chart info user
     * @returns any ok
     * @throws ApiError
     */
    static apiChartsTargetList(dateEnd = '2024-07-05', dateStart = '2024-06-05', keyPeriod, moduleId, user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/charts/target/',
            query: {
                'date_end': dateEnd,
                'date_start': dateStart,
                'key_period': keyPeriod,
                'module_id': moduleId,
                'user': user,
            },
            errors: {
                400: `you must send required query param`,
                403: `forbidden, you have not permission`,
            },
        });
    }
    /**
     * Проверяет существование пользователя в системе
     * @returns any No response body
     * @throws ApiError
     */
    static apiCheckExistUserCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/check_exist_user',
        });
    }
    /**
     * @param exerciseSlug
     * @returns any No response body
     * @throws ApiError
     */
    static apiDetailExerciseRetrieve(exerciseSlug) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/detail_exercise/{exercise_slug}',
            path: {
                'exercise_slug': exerciseSlug,
            },
        });
    }
    /**
     * API endpoint for adding exercise reports.
     *
     * ---
     *
     * ### Request Body
     * - `user` (dict): User data.
     * - `exercise` (dict): Exercise data.
     * - `calibration_data` (dict): Calibration data.
     * - `user_settings_data` (dict): User settings data
     *
     * ### Headers
     * - `jwt` (string, required): API Access Token.
     *
     * ### Responses
     * - 200: Successful response with exercise report id.
     * - 400: Bad request. Details in the response data.
     *
     * ### Examples
     * #### Request
     * ```json
     * {
         * "user": {"id": 123},
         * "exercise": {"id": 456, "info_reps": [...], "final_result": {...}, "abort_exercise": {...}},
         * "calibration_data": {"id": 789},
         * "user_settings_data": {"id": 101}
         * }
         * ```
         *
         * #### Response (Success)
         * ```json
         * {
             * "success": "OK...",
             * "ex_rep_info_id": 123
             * }
             * ```
             * @param requestBody
             * @returns any
             * @throws ApiError
             */
    static apiExerciseReportCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/exercise_report',
            body: requestBody,
            mediaType: 'type',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiExercisesRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/exercises',
        });
    }
    /**
     * View for group list with category and exercises
     * @returns Group
     * @throws ApiError
     */
    static apiExercisesListList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/exercises/list/',
        });
    }
    /**
     * @param formData
     * @returns any
     * @throws ApiError
     */
    static apiExercisesSoundCreateCreate(formData) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/exercises/sound/create/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param number
     * @returns void
     * @throws ApiError
     */
    static apiExercisesSoundDeleteDestroy(number) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/api/exercises/sound/delete/{number}',
            path: {
                'number': number,
            },
        });
    }
    /**
     * @param number
     * @param formData
     * @returns any
     * @throws ApiError
     */
    static apiExercisesSoundUpdatePartialUpdate(number, formData) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/api/exercises/sound/update/{number}',
            path: {
                'number': number,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param slug
     * @returns ExerciseSpeech
     * @throws ApiError
     */
    static apiExercisesSpeechRetrieve(slug) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/exercises/speech/{slug}/',
            path: {
                'slug': slug,
            },
        });
    }
    /**
     * Class for get exercises and video patients
     * @param slug
     * @returns UserVideo
     * @throws ApiError
     */
    static apiExercisesVideoUserRetrieve(slug) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/exercises/video/user/{slug}/',
            path: {
                'slug': slug,
            },
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @returns IPOC
     * @throws ApiError
     */
    static apiGetIpocList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/get_ipoc',
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @param requestBody
     * @returns SetIPOC
     * @throws ApiError
     */
    static apiGetIpocCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/get_ipoc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @returns IPOC
     * @throws ApiError
     */
    static apiGetIpocList2() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/get_ipoc/',
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @param requestBody
     * @returns SetIPOC
     * @throws ApiError
     */
    static apiGetIpocCreate2(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/get_ipoc/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiGroupsRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/groups',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiHelpRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/help',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiLanguagesRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/languages',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiLogFrontendErrorCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/log_frontend_error',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiLogUserBugreportCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/log_user_bugreport',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiLoginApiCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/login_api',
        });
    }
    /**
     * @param moduleSlug
     * @returns any No response body
     * @throws ApiError
     */
    static apiModuleExerciseRetrieve(moduleSlug) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/module_exercise/{module_slug}',
            path: {
                'module_slug': moduleSlug,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiModulesRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/modules',
        });
    }
    /**
     * Remove patient from logopedist
     * @param id
     * @returns void
     * @throws ApiError
     */
    static apiPatientsDestroy(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'DELETE',
            url: '/api/patients/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create payment
     * @param requestBody
     * @returns PurchaseSubscription
     * @throws ApiError
     */
    static apiPaymentCreateCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/payment/create/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accept stripe hooks
     * @returns any No response body
     * @throws ApiError
     */
    static apiPaymentStripeCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/payment/stripe/',
        });
    }
    /**
     * Accept yookassa hooks
     * @returns any No response body
     * @throws ApiError
     */
    static apiPaymentYookassaCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/payment/yookassa/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiPdfToEmailCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/pdf_to_email/',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiPersonificationRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/personification',
        });
    }
    /**
     * @param patientUsername
     * @returns any No response body
     * @throws ApiError
     */
    static apiPersonificationRetrieve2(patientUsername) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/personification/{patient_username}',
            path: {
                'patient_username': patientUsername,
            },
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiRegistrationApiCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/registration_api',
        });
    }
    /**
     * create request from logoped to client
     * @param requestBody
     * @returns any No response body
     * @throws ApiError
     */
    static apiRequestAttachmentCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/request_attachment/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * update status request attachment from logoped
     * @param id
     * @param requestBody
     * @returns AttachRequest
     * @throws ApiError
     */
    static apiRequestAttachmentUpdate(id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/request_attachment/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * update status request attachment from logoped
     * @param id
     * @param requestBody
     * @returns AttachRequest
     * @throws ApiError
     */
    static apiRequestAttachmentPartialUpdate(id, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/api/request_attachment/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any No response body
     * @throws ApiError
     */
    static apiSaveRewardCreate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/save_reward/',
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @returns IPOC
     * @throws ApiError
     */
    static apiSetIpocList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/set_ipoc/',
        });
    }
    /**
     * Класс отдает и изменяет настройки ipoc
     * @param requestBody
     * @returns SetIPOC
     * @throws ApiError
     */
    static apiSetIpocCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/set_ipoc/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Subscription
     * @throws ApiError
     */
    static apiSubscriptionsSubscriptionList() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/subscriptions/subscription/',
        });
    }
    /**
     * @returns TestResult
     * @throws ApiError
     */
    static apiTestLatestResultRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/test/latest_result',
        });
    }
    /**
     * @param requestBody
     * @returns TestResult
     * @throws ApiError
     */
    static apiTestSaveResultCreate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/test/save_result',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UserProfile
     * @throws ApiError
     */
    static apiUpdateSpeedSettingsUpdate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/update_speed_settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UserProfile
     * @throws ApiError
     */
    static apiUpdateSpeedSettingsPartialUpdate(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/api/update_speed_settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получает информацию о пользователе
     * @returns any No response body
     * @throws ApiError
     */
    static apiUserRetrieve() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/user',
        });
    }
    /**
     * Изменяет информацию о пользователе
     * @returns any No response body
     * @throws ApiError
     */
    static apiUserUpdate() {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/user',
        });
    }
    /**
     * Класс отдает и изменяет настройки пользователя
     * @param user
     * @returns UserSettings
     * @throws ApiError
     */
    static apiUsersettingsRetrieve(user) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/api/usersettings/{user}/',
            path: {
                'user': user,
            },
        });
    }
    /**
     * Класс отдает и изменяет настройки пользователя
     * @param user
     * @param requestBody
     * @returns UserSettings
     * @throws ApiError
     */
    static apiUsersettingsUpdate(user, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PUT',
            url: '/api/usersettings/{user}/',
            path: {
                'user': user,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Класс отдает и изменяет настройки пользователя
     * @param user
     * @param requestBody
     * @returns UserSettings
     * @throws ApiError
     */
    static apiUsersettingsPartialUpdate(user, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/api/usersettings/{user}/',
            path: {
                'user': user,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param exSlug
     * @returns any No response body
     * @throws ApiError
     */
    static apiUsersettingsResetPartialUpdate(exSlug) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'PATCH',
            url: '/api/usersettings/reset/{ex_slug}/',
            path: {
                'ex_slug': exSlug,
            },
        });
    }
    /**
     * @param slug
     * @param requestBody
     * @returns UserSettings
     * @throws ApiError
     */
    static apiUsersettingsUpdateCreate(slug, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/api/usersettings/update/{slug}',
            path: {
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.ApiService = ApiService;
